import { Button } from "@bfc-software/pallet";

import styles from "./stat-stepper.module.css";

/**
 * A labelled row with a -/+ numeric control, for the "System-wide settings"
 * card. No pallet `Stepper` exists yet (SR-301 didn't cover one) -- this is a
 * one-off composition of `Button`, local to this screen until a second
 * product wants the pattern (see `outbound-sidebar.tsx`'s own note on the
 * same tradeoff).
 */
export function StatStepper({
  label,
  description,
  value,
  unit,
  min,
  max,
  step = 1,
  onChange,
  isDisabled = false,
  "data-test-role": testRole,
}: {
  label: string;
  description: string;
  value: number;
  unit: string;
  min: number;
  max: number;
  step?: number;
  onChange: (next: number) => void;
  isDisabled?: boolean;
  "data-test-role"?: string;
}) {
  return (
    <div className={styles.row} data-test-role={testRole}>
      <div className={styles.text}>
        <div className={styles.label}>{label}</div>
        <div className={styles.description}>{description}</div>
      </div>
      <div className={styles.control}>
        <Button
          kind="icon-only"
          variant="tertiary"
          icon="Minus"
          label={`Decrease ${label}`}
          isDisabled={isDisabled || value <= min}
          onPress={() => onChange(Math.max(min, value - step))}
        />
        <div className={styles.value} data-test-role="stat-stepper-value">
          <span className={styles.valueNumber}>{value}</span>
          <span className={styles.valueUnit}>{unit}</span>
        </div>
        <Button
          kind="icon-only"
          variant="tertiary"
          icon="Plus"
          label={`Increase ${label}`}
          isDisabled={isDisabled || value >= max}
          onPress={() => onChange(Math.min(max, value + step))}
        />
      </div>
    </div>
  );
}
